import { curry, paths, any, type } from "ramda"
import { isset, isNotNullOrEmpty, isEmptyString, isArray, isEmptyObject, isNotEmptyString } from "../../validate"
const isDateObject = (value) => type(value) === "Date"

export const checkValid = (value) => {
  const isDate = isDateObject(value)
  if (isDate) return true
  if (isNotEmptyString(value)) return true
  if (!isDate && isNotNullOrEmpty(value)) return true

  return false
}

const isAssociatedBRFields = curry((assoDataPaths, { value, forminputdata }) => {
  if (!isArray(assoDataPaths)) return false
  const assoValues = paths(assoDataPaths, forminputdata)
  const isMandatory = any(checkValid)(assoValues)
  if (isMandatory && !isset(value)) return false
  if (isMandatory && !isDateObject(value) && isEmptyObject(value)) return false
  if (isMandatory && isEmptyString(value)) return false
  return true
})

export default isAssociatedBRFields
